const KALEMA = [
  {
    id: "1",
    name: "কালেমা তাইয়্যিবাহ",
    kalemaAr: "لآ اِلَهَ اِلّا اللّهُ مُحَمَّدٌ رَسُوُل اللّهِ",
    kalemaBnU: "লা-ইলা-হা ইল্লাল্লাহু মুহাম্মাদুর রাসূলুল্লাহ্।",
    kalemaBnA:
      "আল্লাহ ছাড়া কোন উপাস্য নাই, হযরত মুহাম্মাদ (সাঃ) তাঁহার প্রেরিত রাসুল।",
    kalemaEn:
      "There is no God but Allah, [and] Muhammad is the messenger of Allah.",
    audio:
      "https://al-quran.technobdapis.com/assets/media/kalima_audio/kalima_taiyaba.mp3",
  },
  {
    id: "2",
    name: "কালেমা শাহাদাত",
    kalemaAr:
      "اشْهَدُ انْ لّآ اِلهَ اِلَّا اللّهُ وَحْدَه لَا شَرِيْكَ لَه، وَ اَشْهَدُ اَنَّ مُحَمَّدً اعَبْدُه وَرَسُولُه",
    kalemaBnU:
      "আশ্হাদু আল-লা-ইলা-হা ইল্লাল্লা-হু ওয়াহ্দাহু-লা-শারীকালাহু ওয়া আশ্হাদু আন্না মুহাম্মাদান আবদুহু ওয়া রাসূলুহু।",
    kalemaBnA:
      "আমি সাক্ষ্য দিতেছি যে, আল্লাহ্ ছাড়া কোন উপাস্য নাই। তিনি এক,অদ্বিতীয় এবং আরও সাক্ষ্য দিতেছি যে, মুহাম্মাদ (সাঃ) তাঁহার বান্দা ও প্রেরিত রাসুল।",
    kalemaEn:
      "I bear witness that (there is) no god except Allah; One is He, no partner hath He, and I bear witness that Muhammad is His Servant and Messenger.",
    audio:
      "https://al-quran.technobdapis.com/assets/media/kalima_audio/kalima_shahadat.mp3",
  },
  {
    id: "3",
    name: "কালেমা তামজীদ",
    kalemaAr:
      "سُبْحَان اللهِ وَالْحَمْدُلِلّهِ وَلا إِلهَ إِلّااللّهُ وَاللّهُ أكْبَرُ وَلا حَوْلَ وَلاَ قُوَّةَ إِلَّا بِاللّهِ الْعَلِيِّ الْعَظِيْم",
    kalemaBnU:
      "সুবহানআল্লাহী ওয়ালহামদু লিল্লাহী ওয়ালা ইলাহা ইল্লাল্লাহু ওয়াল্লাহু আকবার, ওয়ালা হাওলা ওয়ালা কুয়াতা ইল্লা বিল্লাহিল আলিইল আযীম।",
    kalemaBnA:
      "মহিমান্বিত আল্লাহ্র, সমস্ত প্রশংসা আল্লাহ্র। আল্লাহ্ ছাড়া কোন মাবুদ নাই। আল্লাহ্ মহান। সমস্ত পবিত্রতা আল্লাহ্র, সকল প্রশংসা আল্লাহ্র। আল্লাহ্ ছাড়া কোন শক্তি নাই, কোন ক্ষমতা নাই, তিনি সম্মানিত, তিনি মহান।",
    kalemaEn:
      "Exalted is Allah, and praise be to Allah, and there is no deity except Allah, and Allah is the Greatest. And there is no might nor power except in Allah, the Most High, the Most Great.",
    audio:
      "https://al-quran.technobdapis.com/assets/media/kalima_audio/kalima_tamjeed.mp3",
  },
  {
    id: "4",
    name: "কালেমা তাওহীদ",
    kalemaAr:
      "لا الهَ اِلَّا اللّهُ وَحْدَهُ لا شَرِيْكَ لَهْ، لَهُ الْمُلْكُ وَ لَهُ الْحَمْدُ يُحْى وَ يُمِيْتُ وَ هُوَحَىُّ لَّا يَمُوْتُ اَبَدًا اَبَدًا ط ذُو الْجَلَالِ وَ الْاِكْرَامِ ط بِيَدِهِ الْخَيْرُ ط وَهُوَ عَلى كُلِّ شَئ ٍ قَدِيْرٌ",
    kalemaBnU:
      "লা ইলাহা ইল্লাল্লাহু ওয়াহদাহু লা শারিকা লাহু, লাহুল মুলকু ওলাহুল হামদু ইউহয়ী ওয়া ইউমিতু ওয়া হুয়া হাইয়ুল লা ইয়ামুতু আবাদান আবাদা জুল জালালি ওয়াল ইকরাম বি ইয়াদিহিল খাইর ওয়া হুয়া আলা কুল্লি শাইয়িন কাদির",
    kalemaBnA:
      "আল্লাহ ব্যতীত কোন উপাস্য নেই, তিনি এক ও অদ্বিতীয়। তাঁর কোন অংশীদার নেই। সকল ক্ষমতা এবং প্রশংসা তাঁরই জন্য। তিনিই জীবন ও মৃত্যুর মালিক। তিনি চিরঞ্জীব, তিনি সকল সম্মানের মালিক। তাঁর হাতেই সকল মঙ্গল এবং তিনি সবকিছুর উপর ক্ষমতা রাখেন।",
    kalemaEn:
      "(There is) no god except Allah – One is He, no partners hath He. His is the Dominion, and His is the Praise. He gives life and sees to the natural cycle of life, life on Earth ends (death) for there is the eternal after life. He is eternal and ubiquitous. He of Majesty and Munificence. Within His Hand is (all) good. And He is, upon everything, Able (to exert His Will).",
    audio:
      "https://al-quran.technobdapis.com/assets/media/kalima_audio/kalima_tawhid.mp3",
  },
  {
    id: "5",
    name: "কালেমা আস্তাগফার",
    kalemaAr:
      "اَسْتَغْفِرُ اللهَ رَبِّىْ مِنْ كُلِّ ذَنْۢبٍ اَذْنَبْتُهٗ عَمَدًا اَوْ خَطَا ًٔ سِرًّا اَوْ عَلَانِيَةً وَّاَتُوْبُ اِلَيْهِ مِنَ الذَّنْۢبِ الَّذِیْٓ اَعْلَمُ وَ مِنَ الذَّنْۢبِ الَّذِىْ لَآ اَعْلَمُ اِنَّكَ اَنْتَ عَلَّامُ الْغُيُوْبِ وَ سَتَّارُ الْعُيُوْبِ و َغَفَّارُ الذُّنُوْبِ وَ لَا حَوْلَ وَلَا قُوَّةَ اِلَّا بِاللهِ الْعَلِىِّ الْعَظِيْمِؕ",
    kalemaBnU:
      "আস্তাগফিরুল্লাহা রাব্বি মিন কুল্লি জামবি আয নাবতুহু আমাদান আওখাতাআন সিররান আওয়ালা নিয়াতান ওয়াতুবু ইলাইহি মিনাযযামবিল্লাজি ওয়ামিনাযযামবিল্লাজি লা আলামু ইন্নাকা আনতা আল্লামুল গুয়ুবী ওয়া সাত্তারুল উইয়ুবী ওয়া গাফফারুজজুনুবি ওয়ালা হাওলা ওয়ালা কুয়াতা ইল্লা বিল্লাহিল আলিউল আযীম।",
    kalemaBnA:
      "আমি আল্লাহ্র কাছে ক্ষমা চাই সকল পাপ থেকে, যা আমি সংঘটিত করেছি আমার জ্ঞাতসারে অথবা অজ্ঞাতসারে, গোপনে বা প্রকাশ্যে এবং আমি আমার পালনকর্তার আশ্রয় চাই সেই পাপ থেকে, যে পাপ আমি জানি এবং যে পাপ আমি জানিনা। অবশ্যই আপনি লুকানো এবং গোপন (ভুল) পাপ সম্পর্কে জানেন এবং ক্ষমাশীল। আল্লাহ্ ছাড়া কোন শক্তি নেই, কোন ক্ষমতা নেই, তিনি সম্মানিত, তিনি মহান।",
    kalemaEn:
      "I seek forgiveness from Allah, my Lord, from every sin I committed knowingly or unknowingly, secretly or openly, and I turn towards Him from the sin that I know and from the sin that I do not know. Certainly You, You (are) the knower of the hidden things and the Concealer (of) the mistakes and the Forgiver (of) the sins. And (there is) no power and no strength except from Allah, the Most High, the Most Great",
    audio:
      "https://al-quran.technobdapis.com/assets/media/kalima_audio/kalima_astagfar.mp3",
  },
  {
    id: "6",
    name: "কালেমা রদ্দেকুফর",
    kalemaAr:
      "اَللَّهُمَّ اِنِّىْ اَعُوْذُبِكَ مِنْ اَنْ اُشْرِكَ بِكَ شَيْئً وَاَنَا اعَلَمُ بِهِ وَاَسْتَغْفِرُكَ لِمَا اعَلَمُ بِهِ وَمَا لاَاعَلَمُ بِهِ تُبْتُ عَنْهُ وَتَبَرَّأتُ مِنَ الْكُفْرِ وَالشِّرْكِ وَالْمَعَاصِىْ كُلِّهَا وَاَسْلَمْتُ وَاَمَنْتُ وَاَقُوْلُ اَنْ لاَّاِلَهَ اِلاَّاللهُ مُحَمَّدُ رَّسَوْلُ اللهِ",
    kalemaBnU:
      "আল্লাহুম্মা ইন্নী আউযুবিকা মিন আন উশরিকা বিকা শাইআও ওয়া আনা আলামু বিহি ওয়া আসতাগ ফিরুকা লিমা আলামু বিহি ওয়ামা লা আলামু বিহি তুবতু আনহু ওয়া তাবাররাতু মিনাল কুফরি ওয়াশ্শির্কি ওয়াল মা আছি কুল্লিহা ওয়া আসলামতু ওয়া আমানতু ওয়া আক্বলু আল্লা ইলাহা ইল্লাল্লাহু মুহাম্মাদু রাসূলুল্লাহ।",
    kalemaBnA:
      "হে আল্লাহ! আমি তোমার নিকট আশা করছি, যেন কাহাকেও তোমার সহিত অংশীদার না করি। আমার জানা-অজানা গুনাহ হতে ক্ষমা চহিতেছি এবং ইহা হতে তওবা করিতেছি । কুফর, শিরক এবং অন্যান্য সমস্ত গুনাহ হতে বিদুরীত হইতেছি এবং প্রতিজ্ঞা করিতেছি আল্লাহ ব্যতীত অন্য কোন মাবুদ নাই, মুহাম্মদ মুস্তফা (সাল্লাল্লাহু আলাইহে ওয়া সাল্লাম) তাঁহার রাসুল।",
    kalemaEn:
      "O Allah! I seek protection in You from that I should not join any partner with You knowingly. I seek Your forgiveness from that which I do not know. I repent from it (ignorance) I free myself from disbelief and joining partners with You and from all sins. I submit to Your will I believe and I declare: There is none worthy of worship besides Allah and Muhammad (Peace be upon Him) is Allah's Messenger.",
    audio:
      "https://al-quran.technobdapis.com/assets/media/kalima_audio/kalima_raddekufr.mp3",
  },
];

export default KALEMA;
